import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../../../services/config";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
const ViewStaffDetails = ({ EmpDetails, studentDetails }) => {
  console.log(EmpDetails, "this is staf details");

  const [firstlinewidth, setfirstlinewidth] = useState("fit-content");
  const [secondlinewidth, setsecondlinewidth] = useState("fit-content");
  const [loading, setloading] = useState(false);

  const extras = EmpDetails?.employee_defined_extras || [];

  const allowances = extras.filter(
    (item) => item.salary_extras?.is_deduction === 0,
  );

  const deductions = extras.filter(
    (item) => item.salary_extras?.is_deduction === 1,
  );

  const groupByTwo = (arr) => {
    const result = [];
    for (let i = 0; i < arr.length; i += 2) {
      result.push(arr.slice(i, i + 2));
    }
    return result;
  };

  return (
    <div>
      {loading ? (
        <Spinner variant="secondary" animation="border" />
      ) : (
        <>
          <div className="card">
            <h2 style={{ margin: 10 }}>Personal Details</h2>
            <br />
            <div className="col-md-12 d-flex">
              <div className=" d-flex col-md-6 ">
                <div>
                  {" "}
                  <h5>Name : &ensp;</h5>{" "}
                </div>
                <h5
                  title={
                    EmpDetails?.full_name?.length > 15
                      ? EmpDetails?.full_name
                      : null
                  }
                  style={{
                    textAlign: "start",
                    cursor: "pointer",
                    color: "grey",
                  }}
                >
                  {EmpDetails.full_name.length > 15
                    ? "  " + EmpDetails.full_name.substring(0, 12) + "..."
                    : "  " + EmpDetails.full_name}
                </h5>
              </div>
              <div className=" d-flex col-md-6 ">
                <div>
                  {" "}
                  <h5>Gender : &ensp;</h5>{" "}
                </div>
                <h5
                  title={
                    EmpDetails?.gender.length > 15 ? EmpDetails?.gender : null
                  }
                  style={{
                    textAlign: "start",
                    cursor: "pointer",
                    color: "grey",
                  }}
                >
                  {EmpDetails.gender.length > 15
                    ? "  " + EmpDetails.gender.substring(0, 12) + "..."
                    : "  " + EmpDetails.gender}
                </h5>

                {/* <h5 style={{ color: 'grey' }}>Name :{EmpDetails.full_name}</h5> */}
                {/* <h5 style={{ color: 'grey' }}>Gender : {EmpDetails.gender}</h5> */}
              </div>
            </div>
            <hr />
            <div className="col-md-12 d-flex">
              <div className="d-flex col-md-6 ">
                <div>
                  {" "}
                  <h5>Duty : &ensp;</h5>{" "}
                </div>
                <h5
                  title={EmpDetails?.duties_assigned}
                  style={{
                    textAlign: "start",
                    cursor: "pointer",
                    color: "grey",
                  }}
                >
                  {EmpDetails?.duties_assigned}
                </h5>
              </div>
              <div className=" d-flex col-md-6 ">
                <div>
                  {" "}
                  <h5>Job status : &ensp;</h5>{" "}
                </div>
                <h5
                  title={
                    EmpDetails?.job_status_name?.length > 15
                      ? EmpDetails?.job_status_name
                      : null
                  }
                  style={{
                    textAlign: "start",
                    cursor: "pointer",
                    color: "grey",
                  }}
                >
                  {EmpDetails?.job_status_name?.length > 15
                    ? "  " +
                      EmpDetails?.job_status_name.substring(0, 12) +
                      "..."
                    : "  " + EmpDetails?.job_status_name}
                </h5>
              </div>
            </div>
            <hr />

            <div className="col-md-12 d-flex">
              <div className="d-flex col-md-6 ">
                <div>
                  {" "}
                  <h5>Mobile : &ensp;</h5>{" "}
                </div>
                <h5
                  title={
                    EmpDetails?.mobile_no.length > 15
                      ? EmpDetails?.mobile_no
                      : null
                  }
                  style={{
                    textAlign: "start",
                    cursor: "pointer",
                    color: "grey",
                  }}
                >
                  {EmpDetails?.mobile_no.length > 15
                    ? "  " + EmpDetails?.mobile_no.substring(0, 12) + "..."
                    : "  " + EmpDetails?.mobile_no}
                </h5>
              </div>
              {/* <div className=" d-flex col-md-6 ">

                                    <div ><h5 >Payment : &ensp;</h5> </div>
                                    <h5 title={EmpDetails.payment_type.length > 15 ? EmpDetails.payment_type : null} style={{ textAlign: "start", cursor: "pointer", color: 'grey' }}>{EmpDetails.payment_type.length > 15 ? "  " + EmpDetails.payment_type.substring(0, 12) + "..." : "  " + EmpDetails.payment_type}</h5>

                                </div> */}
            </div>

            {/* <div className=" col-md-6 d-flex justify-content-between">
                                <h5 style={{ color: 'grey' }}>Mobile  : {EmpDetails.mobile_no}</h5>
                                <h5 style={{ color: 'grey' }}>Payment : {EmpDetails.payment_type}</h5>

                            </div> */}
            <hr />

            <div className="col-md-12 d-flex">
              {/* <div className="d-flex col-md-6 ">

                                    <div> <h5 >Account Head : &ensp;</h5> </div>
                                    <h5 title={EmpDetails.account_head.length > 25 ? EmpDetails.account_head : null} style={{ textAlign: "start", cursor: "pointer", color: 'grey' }}>{EmpDetails.account_head.length > 25 ? "  " + EmpDetails.account_head.substring(0, 22) + "..." : "  " + EmpDetails.account_head}</h5>
                                </div> */}
              <div className=" d-flex col-md-6 ">
                <div>
                  {" "}
                  <h5>Address : &ensp;</h5>{" "}
                </div>
                <h5
                  title={
                    EmpDetails?.address.length > 25 ? EmpDetails?.address : null
                  }
                  style={{
                    textAlign: "start",
                    cursor: "pointer",
                    color: "grey",
                  }}
                >
                  {EmpDetails?.address.length > 25
                    ? "  " + EmpDetails?.address.substring(0, 22) + "..."
                    : "  " + EmpDetails?.address}
                </h5>
              </div>
            </div>

            {/* <div className=" col-md-6 d-flex justify-content-between">
                                <h5 style={{ color: 'grey' }}>Account Head : {EmpDetails.account_head}</h5>
                                <h5 style={{ color: 'grey' }}>Address: {EmpDetails.address}</h5>

                            </div> */}
            <hr />
          </div>

          <div className="card p-3">
            <h1 className="m-3">Salary details</h1>
            <br />
            <UserDetails
              title="Salary Days"
              value={EmpDetails?.salary_days}
              title2="Social_security_number"
              value2={EmpDetails?.social_security_number}
            />
            <UserDetails
              title="Payment type"
              value={EmpDetails?.payment_type}
              title2="Reg Code"
              value2={EmpDetails.reg_code}
            />
          </div>

          <div className="card p-3">
            <h1 className="m-3">GP Fund details</h1>
            <br />
            <UserDetails
              title="ID"
              value={EmpDetails?.gp_collected_fund?.id}
              title2="Collected Amount"
              value2={EmpDetails?.gp_collected_fund?.collected_amount}
            />
          </div>

          {/* Salary Allowance */}
          <div className="card p-3">
            <h1 className="m-3">Salary Allowance</h1>
            <br />

            {groupByTwo(allowances).map((pair, index) => (
              <UserDetails
                key={index}
                title={pair[0]?.salary_extras?.name || ""}
                value={pair[0]?.value || ""}
                title2={pair[1]?.salary_extras?.name ?? "---"}
                value2={pair[1]?.value ?? "---"}
              />
            ))}
          </div>

          {/* Salary Deduction */}
          <div className="card p-3">
            <h1 className="m-3">Salary Deduction</h1>
            <br />

            {groupByTwo(deductions).map((pair, index) => (
              <UserDetails
                key={index}
                title={pair[0]?.salary_extras?.name || ""}
                value={pair[0]?.value || ""}
                title2={pair[1]?.salary_extras?.name ?? "---"}
                value2={pair[1]?.value ?? "---"}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ViewStaffDetails;

const UserDetails = ({ title, title2, value, value2 }) => {
  return (
    <>
      <div className="col-md-12 d-flex">
        <div className="d-flex col-md-6 ">
          <h5>{title} : &ensp;</h5>
          <h5 style={{ textAlign: "start", cursor: "pointer", color: "grey" }}>
            {" "}
            {value}
          </h5>
        </div>
        <div className=" d-flex col-md-6 ">
          <h5>{title2} : &ensp;</h5>
          <h5 style={{ textAlign: "start", cursor: "pointer", color: "grey" }}>
            {" "}
            {value2}
          </h5>
        </div>
      </div>

      <hr />
    </>
  );
};
